import { render, staticRenderFns } from "./IAvatarLink.vue?vue&type=template&id=3b9acd85&"
import script from "./IAvatarLink.vue?vue&type=script&lang=js&"
export * from "./IAvatarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports